<template>
    <div class="outer-wrapper">
       <div class="container">
            <div class="text-center">
            <h5 class="header-1"><b>Doodhvale</b></h5>
            <h6 class="header-2"><b>Fully Sanitized Delivery with Zero Human Contact</b></h6>
            <h3 class="header-3"><b>Preventive Measures</b></h3>
            <div class="dear-cust-div">
                <h6><b>Dear Customers,</b></h6>
                <p>At Doodhvale, we are strictly monitoring the predominating situation raised due to pandemic. By keeping this in mind, we have created some effective protective measures through intensive safety etiquette across all our workplaces, warehouses, delivery hubs, and pan-India.
                <p>The necessary actions undertaken are mentioned below. These steps, requiring absolute caution and top most importance, are helpful to the health and safety of all</p>
            </div>
            </div>
            <div>
                <div class="row ">
                    <div class="col-2 col-sm-2 col-md-2 tile-l-dv align-self-center"><p><b>1</b></p></div>
                    <div class="col-10 col-sm-10 col-md-10 tile-1-r-dv tile-r-dv align-self-center" >Firstly we would say that all our working staffs are well trained to follow the best sanitation training.</div>
                    <!-- <div class="col-5 col-sm-5 col-md-5">dfs</div> -->
                </div>
                <div class="row ">
                    <div class="col-2 col-sm-2 col-md-2 tile-l-dv align-self-center"><p><b>2</b></p></div>
                    <div class="col-10 col-sm-10 col-md-10 tile-2-r-dv tile-r-dv align-self-center">All our employees are passing through routine screening for symptoms, and are thermally examined before entering the warehouse. </div>
                    <!-- <div class="col-5 col-sm-5 col-md-5">dfs</div> -->
                </div>
                <div class="row ">
                    <div class="col-2 col-sm-2 col-md-2 tile-l-dv align-self-center"><p><b>3</b></p></div>
                    <div class="col-10 col-sm-10 col-md-10 tile-3-r-dv tile-r-dv align-self-center">Before delivery, each of our staff is equipped with safety gear such as sanitizers, masks, and disposable gloves for safe and secure delivery of productswith zero human contacts. </div>
                    <!-- <div class="col-5 col-sm-5 col-md-5">dfs</div> -->
                </div>
                <div class="row ">
                    <div class="col-2 col-sm-2 col-md-2 tile-l-dv align-self-center"><p><b>4</b></p></div>
                    <div class="col-10 col-sm-10 col-md-10 tile-4-r-dv tile-r-dv align-self-center">All executives are given strict instructions on maintaining the social distancing, not to enter while delivering the products just outside your home/bags or leave it at the reception area. </div>
                    <!-- <div class="col-5 col-sm-5 col-md-5">dfs</div> -->
                </div>
                <div class="row ">
                    <div class="col-2 col-sm-2 col-md-2 tile-l-dv align-self-center"><p><b>5</b></p></div>
                    <div class="col-10 col-sm-10 col-md-10 tile-5-r-dv tile-r-dv align-self-center">All our warehouses and workplaces are sanitized and sterilized regularly for complete safety. </div>
                    <!-- <div class="col-5 col-sm-5 col-md-5">dfs</div> -->
                </div>
                <div class="row ">
                    <div class="col-2 col-sm-2 col-md-2 tile-l-dv align-self-center"><p><b>6</b></p></div>
                    <div class="col-10 col-sm-10 col-md-10 tile-6-r-dv tile-r-dv align-self-center">All Delivery patners and employees have been suggested to stay at home if they saw any symptoms of the virus and to get in touch with us for necessary medications. </div>
                    <!-- <div class="col-5 col-sm-5 col-md-5">dfs</div> -->
                </div>
                <div class="row ">
                    <div class="col-2 col-sm-2 col-md-2 tile-l-dv align-self-center"><p><b>7</b></p></div>
                    <div class="col-10 col-sm-10 col-md-10 tile-7-r-dv tile-r-dv align-self-center">To ensure that your health is not compromised, we deliver all our dairy products with zero human contact, uninterrupted, and guarded delivery available at your doorstep. </div>
                    <!-- <div class="col-5 col-sm-5 col-md-5">dfs</div> -->
                </div>
                </div>
                <div class="bottomParaDiv">
                    <p>Kindly recharge your wallet with sufficient balance before placing any order.  Make sure your wallet is recharged with sufficient balance before placing any order. You 
                    can easily recharge your wallet with any of the payment options available in the section of the app.</p>
                    <div class="row payment-options">
                        <div class="col-5 col-sm-5 col-md-5 col-block">
                            <img class="payment-img" src='img/netbanking.png'>
                        </div>
                        <div class="col-5 col-sm-5 col-md-5 col-block right-block">
                            <img class="payment-img" src='img/upi.png'>
                        </div>
                    </div>
                    <div class="row payment-options">
                        <div class="col-5 col-sm-5 col-md-5 col-block">
                            <img class="payment-img" src='img/credit-card.png'>
                        </div>
                        <div class="col-5 col-sm-5 col-md-5 col-block right-block">
                            <img class="payment-img" src='img/m-wallet.png'>
                        </div>
                    </div>
                    <p>We do applaud our delivery superman who takes a daily risk at this time so that our customers can have their orders safely and on time. They are our frontline workers and any appreciation would fall less for them based on the current situation. On behalf of our overall staff at Doodhvale, we give our best wishes to you and your family, stay home, and safe during this epidemic. Thanks for Picking Doodhvale for your Dairy Needs.</p>
                </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>